import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { resetPassword } from "../../../redux/auth/actions";
import { useDispatch } from "react-redux";
import { APP_CONST } from "../../../config/const";
import { Toaster } from "../../../utils/toaster";

import CloseModal from "../../../assets/images/icons/toggle-close.svg";
import ChevronRight from "../../../assets/images/icons/chevron-down.svg";

const ResetPassword = ({ show, handleClose, handleModalShow }) => {
  const dispatch = useDispatch();
  const [otp, setOtpValue] = useState("");
  const [password, setPassword] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  const handleSubmit = async () => {
    if (otp == "" || password == "") {
      Toaster(APP_CONST.TOAST_TYPE.ERROR, "All fields are mandatory");
    } else {
      const response = await resetPassword({
        otp,
        password,
      });
      if (response) {
        Toaster(APP_CONST.TOAST_TYPE.SUCCESS, "Password reset success");
        handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.AUTO);
        handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
      }
    }
  };

  return (
    <Modal
      show={show}
      className={"steps-canvas lgn-reg-modal"}
      onHide={() => {
        console.log("working");
      }}
      placement={"end"}
    >
      <button
        type="button"
        class="close"
        data-dismiss="modal"
        onClick={() => handleClose(APP_CONST.AUTH_MODAL_ACTION_TYPE.MANUAL)}
      >
        <img src={CloseModal} alt="close modal" />
      </button>
      <Modal.Body>
        <Modal.Title>Reset Password</Modal.Title>

        <div className="login-section">
          <div className="form-steps">
            <Form>
              <Form.Group className="form-group" controlId="formBasicOTP">
                <Form.Label>Enter OTP *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter OTP"
                  autoComplete="Off"
                  onChange={(e) => setOtpValue(e.target.value)}
                />
              </Form.Group>
              <Form.Group className="form-group" controlId="formBasicPassword">
                <Form.Label>Enter new password *</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter new password"
                  autoComplete="new-password"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Form.Group>

              <div className="modal-btn">
                <Button
                  className="signup"
                  variant="primary"
                  onClick={handleSubmit}
                  disabled={isVerifying}
                >
                  {!isVerifying ? "Submit" : "Submitting..."}
                </Button>
              </div>
            </Form>

            <div className="lgn-sgnup-ac">
              <span>Don't have an account?</span>
              <a
                href="javascript:void(0)"
                onClick={() => {
                  handleModalShow(APP_CONST.AUTH_MODAL.MOBILE_NUMBER);
                  handleClose(APP_CONST.AUTH_MODAL.LOGIN);
                }}
              >
                Sign up now
                <img src={ChevronRight} alt="chevron right" />
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default ResetPassword;
